import { createContext, useContext, useState } from 'react';

const SessionStatsContext = createContext(null);

const SessionStatsProvider = ({ children }) => {
  const [sessionResults, setSessionResults] = useState({});
  return (
    <SessionStatsContext.Provider value={{ sessionResults, setSessionResults }}>
      {children}
    </SessionStatsContext.Provider>
  );
};

const useSessionStats = () => useContext(SessionStatsContext);

export { SessionStatsProvider, useSessionStats };
